/**
 * Simple Slideshow Custom Element with Flickity
 */

if (!customElements.get("slide-show")) {
  class SlideShow extends HTMLElement {
    constructor() {
      super();
      this.flickity = null;
    }

    connectedCallback() {
      this.loadFlickity().then(() => this.init());
    }

    disconnectedCallback() {
      if (this.flickity) {
        this.flickity.destroy();
        this.flickity = null;
      }
    }

    async loadFlickity() {
      if (window.Flickity) return;
      
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = "https://unpkg.com/flickity@2/dist/flickity.pkgd.min.js";
        script.onload = () => {
          // Load CSS if not present
          if (!document.querySelector('link[href*="flickity"]')) {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = "https://unpkg.com/flickity@2/dist/flickity.min.css";
            document.head.appendChild(link);
          }
          resolve();
        };
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }

    init() {
      const slides = this.querySelectorAll(".carousel__slide");
      if (slides.length === 0) return;

      // Get column count from class name
      const columnsMatch = this.className.match(/medium-up-(\d+)/);
      const columnCount = columnsMatch ? parseInt(columnsMatch[1]) : 4;
      const isMobile = window.innerWidth < 768;

      this.flickity = new Flickity(this, {
        cellSelector: ".carousel__slide",
        cellAlign: "left",
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        groupCells: isMobile ? 1 : columnCount,
        wrapAround: false,
        autoPlay: false,
        accessibility: true,
        resize: true,
        selectedAttraction: 0.025,
        friction: 0.58,
      });

      // Update progress bar on change
      this.flickity.on("change", () => {
        this.updateProgressBar();
      });
      ["ready", "change", "scroll", "settle"].forEach((eventName) => {
        this.flickity.on(eventName, () => {
          window.syncFlickityCarouselA11yState?.(this, ".carousel__slide");
        });
      });
      requestAnimationFrame(() => {
        window.syncFlickityCarouselA11yState?.(this, ".carousel__slide");
      });

      // Handle resize
      window.addEventListener("resize", () => {
        if (this.flickity) this.flickity.resize();
      });
    }

    updateProgressBar() {
      const progressBar = document.querySelector(".flickity-progress--bar");
      if (!progressBar || !this.flickity || this.flickity.slides.length <= 1) return;

      const progress = this.flickity.selectedIndex / (this.flickity.slides.length - 1);
      progressBar.style.width = `${Math.max(0, Math.min(100, progress * 100))}%`;
    }

    // Public methods for external control
    reloadCells() {
      if (this.flickity) this.flickity.reloadCells();
    }

    selectSlide(index, isWrapped = false, isInstant = false) {
      if (this.flickity) this.flickity.select(index, isWrapped, isInstant);
    }

    resize() {
      if (this.flickity) this.flickity.resize();
    }
  }

  customElements.define("slide-show", SlideShow);
}
